export default __webpack_public_path__ + "static/media/ic_alert_close.23c018e1.svg";